import { createContext } from 'react';
import { FundingTransaction } from '../types';

export interface AddPaymentContextProps {
  setSubmitForm?(cb: () => void): void;
  onSubmit?(payments: FundingTransaction[]);
}

export const AddPaymentContext = createContext<AddPaymentContextProps>({});
